import { createContext, useContext, useState, ReactNode } from 'react';

interface AnnouncementBarContextType {
  isVisible: boolean;
  setIsVisible: (visible: boolean) => void;
}

const AnnouncementBarContext = createContext<AnnouncementBarContextType | undefined>(undefined);

export function AnnouncementBarProvider({ children }: { children: ReactNode }) {
  const [isVisible, setIsVisible] = useState(true);

  return (
    <AnnouncementBarContext.Provider value={{ isVisible, setIsVisible }}>
      {children}
    </AnnouncementBarContext.Provider>
  );
}

export function useAnnouncementBar() {
  const context = useContext(AnnouncementBarContext);
  if (context === undefined) {
    throw new Error('useAnnouncementBar must be used within AnnouncementBarProvider');
  }
  return context;
}